import InfoCard from "../../Layout/DesignSystem/InfoCard/InfoCard";
import "./DashboardOwner.css";

const InfoCardsSection = ({
  certifier,
  methodology,
  registry,
  urlRegistry,
  isLoading,
}) => {
  const infoCardsData = [
    {
      key: 1,
      value: certifier ?? 0.0,
      title: "Certifier",
      type: "white-card",
    },
    {
      key: 2,
      value: methodology ?? 0.0,
      title: "Methodology",
      type: "white-card",
    },
    {
      key: 3,
      value: registry ?? "",
      title: "Registry",
      type: "white-card",
      href: urlRegistry || undefined,
    },
  ];

  return (
    <div className="info-card-container-bottom">
      {infoCardsData.map(({ key, href, ...statistic }) => (
        <div key={key} className="info-card-wrapper-bottom">
          <InfoCard
            statistic={statistic}
            isLoading={isLoading}
            href={href}
          />
        </div>
      ))}
    </div>
  );
};

export default InfoCardsSection;

